import{a as n}from"./chunk-RAAYCPUM.js";function o(...i){return n(r,i)}var r=(i,e)=>i/e;export{o as a};
